import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormCar from "./FormCar";
import { Typography } from "@mui/material";
import ModalBox from "../../../ui/ModalBox";
import { useMember } from "../provider";

const Add = () => {
  const [open, setOpen] = useState(false);
  const { mid } = useParams();
  const navigate = useNavigate();

  const { fetchOne: fetchMember } = useMember();
  useEffect(() => {
    fetchMember(mid);
  }, [mid, fetchMember]);

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Car
      </Typography>
      <FormCar handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Car"
        name="Car"
      />
    </>
  );
};

export default Add;
